import Stack from '@mui/material/Stack';
import type { SxProps, Theme } from '@mui/material';
import type { ReactNode } from 'react';
import { useMemo } from 'react';

import type { Slots } from '../../utils/Slots';
import { SlotProvider } from '../../utils/SlotContext';
import { useSlotContext } from '../../utils/useSlotContext';
import { DEFAULT_CARD_DIRECTION, DEFAULT_CARD_SIZE } from './Card.constants';
import { sizeTokens, getActionsStyles } from './Card.styleUtils';

type CardActionsProps = {
    children: ReactNode;
    sx?: SxProps<Theme>;
};

export const CardActions = (props: CardActionsProps) => {
    const { size = DEFAULT_CARD_SIZE, direction = DEFAULT_CARD_DIRECTION } =
        useSlotContext(props, 'card');

    const slots: Slots = useMemo(
        () => ({
            button: { size },
        }),
        [size],
    );

    return (
        <SlotProvider value={slots}>
            <Stack
                direction="row"
                gap={1}
                sx={{
                    ...getActionsStyles(direction, sizeTokens[size]),
                    ...props.sx,
                }}
            >
                {props.children}
            </Stack>
        </SlotProvider>
    );
};
